//include 5

var orderSlides = null; // don't ask
jQuery(function () {
    var beforeMediaQuery = Foundation.MediaQuery.current;
    var elemWrapperAcc = ".tabMobileAccordion";
    var elemContentAcc = ".accordion-item";
    var elemContentActiveAcc = ".is-active .accordion-content";

    //------we set up the deferred object, if it does not already exist--------
    window.pixelpoint = window.pixelpoint || {};
    window.pixelpoint.map = window.pixelpoint.map || {};
    window.pixelpoint.map.promises = window.pixelpoint.map.promises || {};
    window.pixelpoint.map.promises.mediumMapLoaded =
        window.pixelpoint.map.promises.mediumMapLoaded || $.Deferred();
    //-------------------------------------------------------------------------

    orderSlides = function (container, featureGroups, tabName) {
        //*
        tabName = tabName || null;
        container.find(".tabs-title").each(function () {
            var tabTitle = $(this);
            var key = tabTitle.data("ppcarto-switch");

            if (!!tabName && tabName != key) return true;

            var tabId = tabTitle.find("a").attr("href");
            var tab = $(tabId);
            if (tab.length > 0) {
                var features = featureGroups[key];
                if (!!features) features = features.features;
                if (!!features) {
                    var newOrder = [];

                    for (var i in features) {
                        var poiId = features[i].id;
                        var tile = tab.find(`>.item[data-poi-id='${poiId}']`);
                        if (tile.length > 0) {
                            tile.attr("data-element-index", i).data("element-index", i);
                            tile.find("p.number").text(parseInt(i) + 1);
                            newOrder.push(tile);
                        }
                    }

                    for (var i in newOrder) {
                        tab.append(newOrder[i]);
                    }
                }
            }
        });
        //*/
    };

    var initWrapper = function () {
        $(".tabgallery-wrapper").each(function () {
            var $this = $(this);
            var wrapperId = "#" + $(this).attr("id");
            var elemWrapper = wrapperId + ".tabgallery-wrapper .tabgallery";
            var elemContent = ".tabs-panel";
            var elemContentActive = elemContent + ".is-active";

            if ($(wrapperId + " [id^=gallery-tabs]").hasClass("tabMobileAccordion")) {
                if (Foundation.MediaQuery.current == "small") {
                    elemWrapper = wrapperId + " " + elemWrapperAcc;
                    elemContent = elemContentAcc;
                    elemContentActive = elemContent + elemContentActiveAcc;
                }
            }

            /*
            * 11.03.2020 ZP: changes for ticket TPBB-1072.
            * the map will load on demand now
            * */
            initSlickOnTabGallery(elemWrapper, elemContentActive);

            if ($("#ppcarto-medium").length > 0) {
                $(".init-medium-map").on("click", e => {
                    $.when(window.pixelpoint.map.promises.mediumMapLoaded).then(function () {
                        window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.loader + `:related-pois-whole-loader:show`);
                        window.ppcartoMedium.$refs.ppcm.$on("relatedLoaded", function (data) {
                            $(".map-expander").removeClass("inactive");

                            let panels = $(elemWrapper).find(".tabs-panel").map((index, el) => {
                                return $(el).attr("id");
                            });

                            let allComplete = $.Deferred();
                            let parts = [];

                            panels.map((index, panel) => {
                                //intentionally, if there are no panels the loader won't be shown
                                let slider = $(`${elemWrapper} #${panel}`);
                                if (!slider.hasClass("all-loaded")) {
                                    let done = $.Deferred();
                                    loadAllElements(elemWrapper, `#${panel}`).done(function (data) {
                                        allComplete.then(() => {
                                            populateMissingData(elemWrapper, `#${panel}`, data, false);
                                        });
                                        done.resolve();
                                    });
                                    parts.push(done.promise());
                                }
                            });
                            $.when.apply($, parts).then(() => {
                                allComplete.resolve();
                            });

                            allComplete.then(() => {
                                orderSlides($this, data.featureGroups);
                                ppcartoTabGalleryInit(elemWrapper, elemContent);
                                setTimeout(() => {
                                    let activeTab = $(".tabgallery-wrapper .tabs-title.is-active");
                                    if (activeTab.length > 0) {
                                        ppcartoTabGalleryChange(activeTab);
                                        activeTab.find("> a").click();
                                        setTimeout(() => {
                                            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.loader + `:related-pois-whole-loader:hide`);
                                        }, 200);
                                    }
                                }, 50);
                            });
                        });
                    });
                });
            }
        });


        $(".tabmosaic-wrapper").each(function () {
            if ($(this).hasClass("mobile-mosaic-to-slick-slider")) {
                var wrapperId = "#" + $(this).attr("id");
                var elemWrapper = wrapperId + ".tabmosaic-wrapper .tabmosaic";
                var elemContent = ".tabs-panel";
                var elemContentActive = elemContent + ".is-active .mosaic-slick-slider";

                if (Foundation.MediaQuery.current == "small") {
                    if ($(wrapperId + " [id^=gallery-tabs]").hasClass("tabMobileAccordion")) {
                        elemWrapper = wrapperId + " " + elemWrapperAcc;
                        elemContent = elemContentAcc;
                        elemContentActive =
                            elemContent + elemContentActiveAcc + " .mosaic-slick-slider";
                    }
                    initSlickOnTabMosaic(elemWrapper, elemContentActive);
                } else if ($(this).hasClass("medium-mosaic-to-slider") && Foundation.MediaQuery.current == "medium") {
                    initSlickOnTabMosaic(elemWrapper, elemContentActive);
                } else {
                }
            }
        });
    }

   	// #31628
    $(window).on("load", function() {
		initWrapper();
	});

    var clickHandler = function (e) {
        e.preventDefault();
        
        let $target = $(this);
        let contentId = "";

        // Since we're binding to the <a> element, $(this) should be the link
        if ($target.is("a")) { 
            contentId = $target.attr("href");
            // Pass the parent .tabs-title to titleClickEvent, not the link itself
            titleClickEvent($target.parent());
        } else {
            // Fallback: if somehow bound to parent, find the link
            let $link = $target.find("a").first();
            if ($link.length > 0) {
                contentId = $link.attr("href");
                titleClickEvent($target);
            }
        }

        // add class to parent before slick initialises
        if (contentId && $(contentId).length > 0 && !$(contentId).hasClass("slick-initialized")) {
            $(contentId).closest(".tabs-content").addClass("fixed-height");
        }
    };

    // Event handler for both click and keyboard events  
    var tabEventHandler = function(e) {
        if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
            clickHandler.call(this, e);
        }
    };

    // Initial event binding
    $("[id^=gallery-tabs] .tabs-title > a, [id^=gallery-tabs] .accordion-title > a").on('click keydown', tabEventHandler);

    window.ppComponents.sliders.tabGallery = {
        init: function (force) {
            if (beforeMediaQuery != Foundation.MediaQuery.current || !!force) {
                beforeMediaQuery = Foundation.MediaQuery.current;

                $(".tabmosaic-wrapper").each(function () {
                    var $this = $(this);
                    var wrapperId = "#" + $this.attr("id");
                    var elemWrapper = wrapperId + ".tabmosaic-wrapper .tabmosaic";
                    var elemContent = ".tabs-panel";
                    var elemContentActive =
                        elemContent + ".is-active .mosaic-slick-slider";

                    if (
                        $(wrapperId + " [id^=gallery-tabs]").hasClass("tabMobileAccordion")
                    ) {
                        elemWrapper = wrapperId + " " + elemWrapperAcc;
                        elemContent = elemContentAcc;
                        elemContentActive =
                            elemContent + elemContentActiveAcc + " .mosaic-slick-slider";
                    }

                    setTimeout(function () {
                        $(wrapperId + " .slick-initialized").each(function () {
                            $(this).slick("unslick");
                        });

                        $(wrapperId + " .more-wrapper").each(function () {
                            $(this).removeClass("active");
                            $(this).removeAttr("style");

                            addReadMoreButtons(
                                $(this),
                                "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                                50
                            );
                        });

                        if ($this.hasClass("mobile-mosaic-to-slick-slider")) {
                            if (Foundation.MediaQuery.current == "small") {
                                initSlickOnTabMosaic(elemWrapper, elemContentActive);
                            } else if (
                                $this.hasClass("medium-mosaic-to-slider") &&
                                Foundation.MediaQuery.current == "medium"
                            ) {
                                initSlickOnTabMosaic(elemWrapper, elemContentActive);
                            } else {
                            }
                        }
                    }, 200);
                });

                $(".tabgallery-wrapper").each(function () {
                    var $this = $(this);
                    var wrapperId = "#" + $this.attr("id");

                    var elemWrapper = wrapperId + ".tabgallery-wrapper .tabgallery";
                    var elemContent = ".tabs-panel";
                    var elemContentActive = elemContent + ".is-active";

                    if (
                        $(wrapperId + " [id^=gallery-tabs]").hasClass("tabMobileAccordion")
                    ) {
                        if (Foundation.MediaQuery.current == "small") {
                            elemWrapper = wrapperId + " " + elemWrapperAcc;
                            elemContent = elemContentAcc;
                            elemContentActive = elemContent + elemContentActiveAcc;
                        }
                    }

                    setTimeout(function () {
                        $(wrapperId + " .slick-initialized").each(function () {
                            $(this).slick("unslick");
                        });

                        initSlickOnTabGallery(elemWrapper, elemContentActive);
                    }, 200);
                });

                $("[id^=gallery-tabs] .tabs-title > a, [id^=gallery-tabs] .accordion-title > a").off('click keydown');

                setTimeout(function () {
                    $("[id^=gallery-tabs] .tabs-title > a, [id^=gallery-tabs] .accordion-title > a").on('click keydown', tabEventHandler);
                }, 200);
            }
        },
        initWrapper: initWrapper,
        initTabClickEvents: function () {
            $("[id^=gallery-tabs] .tabs-title > a, [id^=gallery-tabs] .accordion-title > a").on('click keydown', tabEventHandler);
        }
    };

    $(window).on("orientationchange resize", window.ppComponents.sliders.tabGallery.init);
});

function loadAllElements(elemWrapper, elemId) {
    var deferred = $.Deferred();

    var slider = null;
    if (elemWrapper && elemId) {
        slider = $(elemWrapper + " " + elemId);
    } else if (elemWrapper instanceof jQuery) {
        slider = elemWrapper;
    } else if (!!elemWrapper) {
        slider = $(elemWrapper);
    }

    if (!!slider) {
        var type = slider.data("type");
        var id = slider.data("id");
        if (!type || !id) {
            deferred.reject();
            return deferred;
        }
        var tab = slider.data("ppcarto-hover");

        // getting the latitude and longitude, if existing ---
        var lat = null,
            lon = null;
        var container = slider.closest(".tabgallery-wrapper.related-offers");
        if (container.length > 0) {
            lat = container.data("lat") || null;
            lon = container.data("lon") || null;
        }
        // ---------------------------------------------------

        var parameters = {
            pp_type: type,
            pp_id: id
        };
        if (!!tab) parameters["pp_tab"] = tab;
        if (!!lat && !!lon) {
            parameters["lat"] = lat;
            parameters["lon"] = lon;
        }
        var relatedAjaxUrl = window.pixelpoint.utilities.getAjaxUrl(window.pixelpoint.settings.relatedAjaxUrl);
        $.get(`${relatedAjaxUrl}`, parameters, null, 'json')
            .done(function (data) {
                deferred.resolve(data.data);
            })
            .fail(function () {
                deferred.reject();
            });
    } else {
        deferred.reject();
    }
    return deferred;
}

function initSlickOnTabGallery(elemWrapper, elemId, currentSlide) {
    currentSlide = typeof currentSlide == "undefined" ? -1 : currentSlide;
    var slider = null;
    if (!!elemWrapper && !!elemId) {
        slider = $(elemWrapper + " " + elemId);
    } else if (elemWrapper instanceof jQuery) {
        slider = elemWrapper;
    } else if (!!elemWrapper) {
        slider = $(elemWrapper);
    }

    if (!!slider) {
        var centerPadding = "-15px", infinite = true;
        if (slider.find(".item").length <= 6) {
            var centerPadding = "0", infinite = false;
        }

        var centerPaddingTest = $(elemWrapper).width() / 4;

        var prevText = slider.data("prev-text");
        var nextText = slider.data("next-text");

        if (slider.find(".item").length <= 6) {
            slider.addClass("all-loaded");
        }

        /**
         * ZP change 26.03.2020: remove class from parent after slider initialises
         */
        slider.on("init", () => {
            slider.closest(".tabs-content").removeClass("fixed-height");
        });

        slider.slick({
            slide: ".item",
            infinite: infinite,
            lazyLoad: "ondemand",
            centerPadding: centerPadding,
            swipeToSlide: true,
            prevArrow:
                '<button class="prev" title=" ' +
                prevText +
                ' "><i aria-label=" ' +
                prevText +
                ' " class="icon-arrow-big-left"></i></button>',
            nextArrow:
                '<button class="next" title=" ' +
                nextText +
                ' "><i aria-label=" ' +
                nextText +
                ' " class="icon-arrow-big-right"></i></button>',
            slidesToShow: 6,
            slidesToScroll: 1,
            centerMode: slider.find(".item").length >= 6 ? false : true,
            initialSlide: slider.find(".item").length >= 6 ? 0 : 3,
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 4,
                        centerMode: slider.find(".item").length >= 4 ? false : true,
                        initialSlide: slider.find(".item").length >= 4 ? 0 : 2, 
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        centerPadding: "-5px",
                        slidesToShow: 3,
                        centerMode: true,
                        initialSlide: 1
                    }
                },
                {
                    breakpoint: 639,
                    settings: {
                        slidesToShow: 2,
                        initialSlide: 0,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 520,
                    settings: {
                        centerPadding: centerPaddingTest + "px",
                        slidesToShow: 1,
                        centerMode: true
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        centerPadding: centerPaddingTest - 50 + "px"
                    }
                }
            ]
        });

        slider
            .off("beforeChange")
            .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                if (!slider.hasClass("all-loaded")) {
                    window.pixelpoint.pubSub.publish(
                        window.pixelpoint.pubSub.events.loader + `:related-pois-loader:show`
                    );
                    loadAllElements(elemWrapper, elemId).done(function (data) {
                        populateMissingData(elemWrapper, elemId, data, true);
                    });
                }
            });
        equalHeight(slider.find(".item"), true);
    }
}

function buildTemplateData(element, index) {
    var item = element;
    var isEvent = false;
    if (!!element && !!element.event) {
        item = element.event;
        isEvent = true;
    } else if (!!element && typeof element.event_dates != "undefined") {
        isEvent = true;
    }

    var data = {};

    data.formatted_date_html = "";

    if (!element.htmlFortmattedTime && !element.formattedFrom && !element.spansMultipleDays && element.closest_event_date && isEvent) {
        element = element.closest_event_date;
        //data.isFullWidth = "";
        element.number = parseInt(index) + 1;
        data.formatted_date_html = "";
        if (element.from_date) {
            var e_date = new Date(element.from_date);
            var e_date_d = ("0" + e_date.getDate()).slice(-2);
            var e_date_m = ("0" + parseInt(e_date.getMonth()+1)).slice(-2);
        }
        var e_from_time_t = "";
        if (element.from_time) {
            var e_from_time = new Date(element.from_time);
            e_from_time_t = ("0" + e_from_time.getHours()).slice(-2) + ":" + ("0" + e_from_time.getMinutes()).slice(-2);
        }
        var e_to_time_t = "";
        if (element.to_time) {
            var e_to_time = new Date(element.to_time);
            e_to_time_t = ("0" + e_to_time.getHours()).slice(-2) + ":" + ("0" + e_to_time.getMinutes()).slice(-2);
        }
        data.formatted_date_html = '<div class="date date-2-cols"><div class="date-col"><div class="startDate">' + e_date_d + '.' + e_date_m + '.<i>2023</i></div></div><div class="time"><i class="icon-clock"></i>'+ e_from_time_t +'<i> '+e_to_time_t+'</i></div></div>';
    }

    data.isFullWidth = "";
    if (!!element.from_time) {
        data.isFullWidth = "fullwidth";
    }
    if (!!element.to_time) {
        data.isFullWidth = "fullwidth";
    }

    // -------- colorClass --------------------------
    data.colorClass = "default";
    if (!!item.sections && !!item.sections.length) {
        for (var i in item.sections) {
            if (
                window.pixelpoint.settings.highlightSections.indexOf(item.sections[i]) >
                -1
            ) {
                data.colorClass = item.sections[i];
                break;
            }
        }
    }
    // ----------------------------------------------
    // -------- relatedElement ----------------------
    data.relatedElement = element;
    // ----------------------------------------------
    // -------- relatedElementIterator --------------
    data.relatedElementIterator = {
        index: index
    };
    // ----------------------------------------------
    // -------- imgUrl & imgAlt && imgAlternative ---

    var assetType = "";
    var replacementType = "poi";
    if (isEvent) {
        assetType = "event/";
        replacementType = "event";
    }

  if (!!item.image && !!item.image.id)
    data.imgUrl = `${window.pixelpoint.domainService.get('apiEndpoint')}${assetType}asset/${item
      .image.id}/thumbnail/173/103.jpg`;
  else
    data.imgUrl = `${window.pixelpoint.settings
      .apiUrl}${replacementType}/${item.id}/placeholder.jpg?second=1`;
  if (!!item.image && !!item.image.alt) data.imgAlt = item.image.alt;
  else {
    if (!!item.data && !!item.data.name) data.imgAlt = item.data.name;
    else if (!!item.name) data.imgAlt = item.name;
    else data.imgAlt = item.title;
  }
  data.imgAlternative = `${window.pixelpoint.settings
    .apiUrl}${replacementType}/${item.id}/placeholder.jpg?third=1`;
  // ----------------------------------------------
  // -------- infoClass ---------------------------
  data.infoClass = "";
  if (!!element.distance || !!element.openinghours) {
    data.infoClass = "withBottomInfo";
  }
  // ----------------------------------------------
  // -------- elementLink && elementTitle ---------
  data.elementLink = element.elementLink;
  if (!data.elementLink && !!element.slug) data.elementLink = element.slug;
  data.elementTitle = "";
  if (!!item.data && !!item.data.name) {
    data.elementTitle = item.data.name;
  } else if (!!item.name) {
    data.elementTitle = item.name;
  } else if (!!item.title) {
    data.elementTitle = item.title;
  }
  data.croppedElementTitle = data.elementTitle;

    if (data.croppedElementTitle.length > 35) {
        data.croppedElementTitle = data.croppedElementTitle.replace(
            /^(.{35}[^\s]*).*/,
            "$1"
        );

        if (data.croppedElementTitle.length > 35) {
            var lastIndex = data.croppedElementTitle.lastIndexOf(" ");

            data.croppedElementTitle = data.croppedElementTitle.substring(
                0,
                lastIndex
            );
        }

        data.croppedElementTitle = data.croppedElementTitle + "...";
    }
    // ----------------------------------------------
    // -------- categories --------------------------
    data.categories = "";
    if (!!item.categories && item.categories.length > 0)
        data.categories = _.map(item.categories.slice(0, 3), category => {
            return category.name;
        }).join(", ");
    if (data.categories.length > 25) {
        data.categories = data.categories.substring(0, 25) + "...";
    }
    // ----------------------------------------------
    // -------- regionPlace -------------------------
    data.regionPlace = "";

    var location = "";
    if (!!item.location) {
        location = item.location.name;
    }
    data.regionPlace = location;

    // ----------------------------------------------
    // -------- distance ----------------------------
    data.distance = element.distance || 0;
    // ----------------------------------------------
    // -------- openinghoursJson --------------------
    data.openingHoursJson = "";
    if (!(!item.openingHoursJson || item.openingHoursJson.length == 0)) {
        data.openingHoursJson = JSON.stringify(item.openingHoursJson);
    }
    // ----------------------------------------------
    // -------- eventTime ---------------------------
    data.eventTime = "";
    if (isEvent) {
        if (!!element.htmlFortmattedTime) {
            data.eventTime = element.htmlFortmattedTime;
        } else {
            if (!!element.formattedFrom) data.eventTime = element.formattedFrom;
            if (!!element.spansMultipleDays)
                data.eventTime += " - " + element.formattedTo;
        }
    }
    // ----------------------------------------------
    return data;
}

function populateMissingData(elemWrapper, elemId, data, tabOrMosaic, preserveLoader) {
    if (data.length == 0) return;

    var slider = null;
    if (!!elemWrapper && !!elemId) {
        slider = $(elemWrapper + " " + elemId);
    } else if (elemWrapper instanceof jQuery) {
        slider = elemWrapper;
    } else if (!!elemWrapper) {
        slider = $(elemWrapper);
    }

    var currentSlide = -1;
    if (slider.hasClass("slick-initialized")) {
        currentSlide = slider.slick("slickCurrentSlide");
        slider.slick("unslick");
    }

    var template = _.template($("#related-items-template").html());

    slider.html("");
    for (var i in data) {
        var parameters = buildTemplateData(data[i], i);
        var html = template(parameters);

        slider.append(html);
    }
    var tabName = slider.data("ppcartoHover");
    if (typeof window.ppcartoMedium != "undefined") {
        orderSlides(
            $(elemWrapper).closest(".tabgallery-wrapper.related-offers"),
            window.ppcartoMedium.$refs.ppcm.featureGroups,
            tabName
        );
    }
    slider.addClass("all-loaded");
    window.pixelpoint.initOpeningHoursText();
    if (!!tabOrMosaic) reinitSlickSliderOnTabGallery(slider, null, currentSlide);
    else reinitSlickOnTabMosaic(slider, null, currentSlide);
    equalHeight(slider.find(".item"), true);
    window.pixelpoint.images.initializeErrors(slider);
    if (!preserveLoader)
        window.pixelpoint.pubSub.publish(
            window.pixelpoint.pubSub.events.loader + `:related-pois-loader:hide`
        );
}

function reinitSlickSliderOnTabGallery(elemWrapper, elemId, currentSlide) {
    var slider = null;
    if (!!elemWrapper && !!elemId) {
        slider = $(elemWrapper + " " + elemId);
    } else if (elemWrapper instanceof jQuery) {
        slider = elemWrapper;
    } else if (!!elemWrapper) {
        slider = $(elemWrapper);
    }

    /**
     * ZP change 26.03.2020: add class to parent before slick initialises
     */
    slider.closest(".tabs-content").addClass("fixed-height");

    if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
    }
    currentSlide = typeof currentSlide == "undefined" ? -1 : currentSlide;
    initSlickOnTabGallery(elemWrapper, elemId, currentSlide);
}

function initSlickOnTabMosaic(elemWrapper, elemId, currentSlide) {
    var slider = null;
    if (!!elemWrapper && !!elemId) {
        slider = $(elemWrapper + " " + elemId);
    } else if (elemWrapper instanceof jQuery) {
        slider = elemWrapper;
    } else if (!!elemWrapper) {
        slider = $(elemWrapper);
    }

    if (!!slider) {
        var centerMode = slider.find(".item").length > 3;

        var prevText = slider.data("prev-text");
        var nextText = slider.data("next-text");

        currentSlide = typeof currentSlide == "undefined" ? -1 : currentSlide;

        if (slider.find(".item").length <= 6) {
            slider.addClass("all-loaded");
        }

        slider.not('.slick-initialized').slick({
            slide: ".item",
            centerMode: centerMode,
            centerPadding: "35px",
            prevArrow:
                '<button class="prev" title=" ' +
                prevText +
                ' "><i aria-label=" ' +
                prevText +
                ' " class="icon-arrow-big-left"></i></button>',
            nextArrow:
                '<button class="next" title=" ' +
                nextText +
                ' "><i aria-label=" ' +
                nextText +
                ' " class="icon-arrow-big-right"></i></button>',
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: currentSlide > -1 ? currentSlide : 1,
            //autoplay: true,
            autoplaySpeed: 1800,
            cssEase: "ease-in-out",
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        centerPadding: "30px",

                        centerMode: false,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        centerPadding: "0px",
                        slidesToShow: 1
                    }
                }
            ]
        });
        slider
            .off("beforeChange")
            .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                if (!slider.hasClass("all-loaded")) {
                    window.pixelpoint.pubSub.publish(
                        window.pixelpoint.pubSub.events.loader + `:related-pois-loader:show`
                    );
                    loadAllElements(elemWrapper, elemId).done(function (data) {
                        populateMissingData(elemWrapper, elemId, data, false);
                    });
                }
            });
        equalHeight(slider.find(".item"), true);
    }
}

function reinitSlickOnTabMosaic(elemWrapper, elemId, currentSlide) {
    var slider = null;
    if (!!elemWrapper && !!elemId) {
        slider = $(elemWrapper + " " + elemId);
    } else if (elemWrapper instanceof jQuery) {
        slider = elemWrapper;
    } else if (!!elemWrapper) {
        slider = $(elemWrapper);
    }
    if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
    }
    currentSlide = typeof currentSlide == "undefined" ? -1 : currentSlide;
    initSlickOnTabMosaic(elemWrapper, elemId, currentSlide);
}

function resetSliderOnClick(
    $thisClickedElem,
    elemtype,
    id,
    elemWrapper,
    elemContent
) {
    $(elemWrapper + " " + id).css("opacity", 0);

    $(id)
        .parent()
        .find(elemContent)
        .each(function () {
            if ($thisClickedElem.hasClass("slick-initialized")) {
                $thisClickedElem.slick("unslick");
            }
        });

    setTimeout(function () {
        if ($(elemWrapper + " " + id).hasClass("slick-initialized")) {
            $(elemWrapper + " " + id).slick("unslick");
        }

        /**
         * ZP change 26.03.2020: add class to parent before slick initialises
         */

        if (elemtype == "tabgallery") {
            $(elemWrapper + " " + id).closest(".tabs-content").addClass("fixed-height");
            initSlickOnTabGallery(elemWrapper, id);
        } else if (elemtype == "tabmosaic") {
            initSlickOnTabMosaic(elemWrapper, id);
        } else {
        }

        $(elemWrapper + " " + id).css("opacity", 1);
    }, 300);
}

function titleClickEvent($thisClickedElem) {
    if ($("#ppcarto-medium").length > 0) {
        ppcartoTabGalleryChange($thisClickedElem);
    }

    if (
        $thisClickedElem.data("ppcarto-switch") == "event" ||
        $thisClickedElem.parent().data("ppcarto-switch") == "event"
    ) {
        $(".dce-map-related-offers .event-more-button")
            .first()
            .removeClass("hide");
    } else {
        $(".dce-map-related-offers .event-more-button")
            .first()
            .addClass("hide");
    }

    var id = "";

    if ($thisClickedElem.is("a")) {
        id = $thisClickedElem.attr("href");
    } else {
        id = $thisClickedElem.children("a:first").attr("href");
    }

    var idSplit = id.split("-");
    var wrapperId = "#c" + idSplit[1];
    var elemtypeClick, elemWrapperClick;
    var elemContentClick = ".tabs-panel";

    $(wrapperId + " .more-wrapper").each(function () {
        var exposed = $(this).data("show-more");
        if (!!exposed && !!exposed.close) exposed.close();
    });
    setTimeout(function () {
        window.ppComponents.common.showMore($(id + " .more-wrapper"));
    }, 500);

    if ($(".tabgallery-wrapper " + id).length > 0) {
        elemtypeClick = "tabgallery";
        elemWrapperClick = wrapperId + ".tabgallery-wrapper .tabgallery";

        if ($thisClickedElem.hasClass("accordion-title")) {
            elemWrapperClick = wrapperId + " " + ".tabMobileAccordion";
            elemContentClick = ".accordion-item";
        }

        resetSliderOnClick(
            $thisClickedElem,
            elemtypeClick,
            id,
            elemWrapperClick,
            elemContentClick
        );
    } else if ($(".tabmosaic-wrapper " + id).length > 0) {
        elemtypeClick = "tabmosaic";
        elemWrapperClick = wrapperId + ".tabmosaic-wrapper .tabmosaic";

        if ($thisClickedElem.hasClass("accordion-title")) {
            elemWrapperClick = wrapperId + " " + ".tabMobileAccordion";
            elemContentClick = ".accordion-item";
        }

        if ($(wrapperId).hasClass("mobile-mosaic-to-slick-slider")) {
            if (Foundation.MediaQuery.current == "small") {
                id = id + " .mosaic-slick-slider";

                resetSliderOnClick(
                    $thisClickedElem,
                    elemtypeClick,
                    id,
                    elemWrapperClick,
                    elemContentClick
                );
            } else if (
                $(wrapperId).hasClass("medium-mosaic-to-slider") &&
                Foundation.MediaQuery.current == "medium"
            ) {
                id = id + " .mosaic-slick-slider";

                resetSliderOnClick(
                    $thisClickedElem,
                    elemtypeClick,
                    id,
                    elemWrapperClick,
                    elemContentClick
                );
            } else {
            }
        }

        window.pixelpoint.lazy.init($(".tabmosaic-wrapper " + id).find(".lazy"));
        window.pixelpoint.lazy.initInterchange($(".tabmosaic-wrapper " + id).find("[data-lazy-interchange]"));
    } else {
    }
}

function getEventId(url) {
    return fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the JSON from the response
        })
        .catch((error) => {
            console.error('Error loading JSON:', error);
            throw error;
        });
}

function ppcartoTabGalleryInit(elemWrapper, elemContent) {
    $(
        elemWrapper + " " + elemContent + "[data-ppcarto-hover]"
    ).on("click", ".item", function (e) {
        var hoveredItem = $(e.target);
        var layer = hoveredItem
            .closest("[data-ppcarto-hover]")
            .data("ppcarto-hover");

        if (!!layer) {
            var itemId = hoveredItem.closest(".item").data("poi-id");
            if (!!itemId) {
                if (
                    !!ppcartoMedium &&
                    !!ppcartoMedium.$refs &&
                    !!ppcartoMedium.$refs.ppcm
                ) {
                    if (layer == "default") layer = "angebote";
                    ppcartoMedium.$refs.ppcm.focusItem(layer, itemId);
                }
            }
        }
    });

    var popupTileTimeout = null;

    var moveToElement = function (data) {
        if (!data) return;
        var layer = data.layer;
        var id = data.id;

        if (!layer || !id) {
            return;
        }

        var tab = $(`[data-ppcarto-switch='${layer}']`);
        if (tab.length == 0) return;
        if (!tab.hasClass("is-active")) {
            tab.click();
        }

        if (!!popupTileTimeout) clearTimeout(popupTileTimeout);
        popupTileTimeout = setTimeout(function () {
            var tabContent = $(`[data-ppcarto-hover="${layer}"]`);
            if (tabContent.length > 0) {
                var gotoSlide = function () {
                    if (tabContent.hasClass("slick-initialized")) {
                        var slide = tabContent.find(`[data-poi-id='${id}']`);    

                        if (slide.length > 0) {
                            var slideId = slide.data("element-index");
                            slide.index($(".mySlick").slick.$slides);
                            tabContent.slick("slickGoTo", slideId);
                            setTimeout(() => {
                                slide.addClass("map-hover");
                            }, 100);
                        }
                    }
                };

                if (!tabContent.hasClass("all-loaded")) {
                    window.pixelpoint.pubSub.publish(
                        window.pixelpoint.pubSub.events.loader + `:related-pois-loader:show`
                    );
                    loadAllElements(tabContent).done(function (data) {
                        var isTabGallery =
                            tabContent.closest(".tabgallery-wrapper").length > 0;
                        populateMissingData(tabContent, null, data, isTabGallery);
                        gotoSlide();
                    });
                } else {
                    gotoSlide();
                }
            }
            popupTileTimeout = null;
        }, 300);
    };
    if (
        !!window.ppcartoMedium &&
        !!window.ppcartoMedium.$refs &&
        !!window.ppcartoMedium.$refs.ppcm
    ) {
        window.ppcartoMedium.$refs.ppcm.$on("highlightover", function (data) {            
            moveToElement(data);
        });
        window.ppcartoMedium.$refs.ppcm.$on("highlightout", function (data) {
            $(".item.map-hover").removeClass("map-hover");
        });

        let activeTab = $(".tabgallery-wrapper li.tabs-title.is-active");
        if (activeTab.length > 0) {
            var ppcartoSwitch = activeTab.data("ppcarto-switch");
            window.ppcartoMedium.$refs.ppcm.activeLayer = ppcartoSwitch;
        }
    }
}

function ppcartoTabGalleryChange($this) {
    //we change the map
    var ppcartoSwitch = $this.data("ppcarto-switch");

    if ($this.is("a")) {
        ppcartoSwitch = $this.parent().data("ppcarto-switch");
    }

    if (!!ppcartoSwitch) {
        if (
            typeof ppcartoMedium != "undefined" &&
            !!ppcartoMedium.$refs &&
            !!ppcartoMedium.$refs.ppcm
        ) {
            ppcartoMedium.$refs.ppcm.switchLayer(ppcartoSwitch);

            var tabContent = $(`[data-ppcarto-hover="event"]`);
            if (tabContent.length > 0) {
        
                tabContent.each(function() {
    
                    $(this).find('[data-poi-id]').each(function() {
    
                        var eventDateId = $(this).data('poi-id');
                        var eventDateJson = `${window.pixelpoint.settings.apiUrl}eventdate/${eventDateId}`;
    
                        getEventId(eventDateJson)
                        .then(data => {
                            $(this).attr('data-poi-id', data.event_date.event_id);
                        })
                        .catch(error => {
                            console.error('Error in fetching JSON:', error);
                        });                                    
    
                    });
                });
            }
        }
    }
}